import React from 'react';
import { parseLocalDate } from '../utils/safeDate';

/**
 * Renders the `invoice_sent_date` cell exactly the way the Accounts
 * Receivable board does so every project board displays it identically:
 *  - blank value -> em-dash
 *  - aging > 90 days -> red bold (unless bad-debt)
 *  - aging > 60 days -> orange bold (unless bad-debt)
 *  - tooltip shows days-since-sent
 *
 * Uses `parseLocalDate` so a stored "YYYY-MM-DD" string is rendered for
 * the same calendar day the user picked — without this, JS parses the
 * string as UTC midnight and shifts it back one day in any timezone
 * west of UTC (e.g. 2026-06-08 -> "6/7/2026" in Eastern).
 */
const InvoiceSentDateCell = ({ project }) => {
  const raw = project.invoice_sent_date;
  if (!raw) return <span className="text-gray-400">—</span>;
  const d = parseLocalDate(raw);
  if (!d) return raw;
  const display = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
  const days = Math.floor((Date.now() - d.getTime()) / (24 * 60 * 60 * 1000));
  const isBadDebt = (project.job_type || '').toLowerCase() === 'bad debt';
  const cls = isBadDebt
    ? 'text-gray-700'
    : days > 90
      ? 'text-red-600 font-medium'
      : days > 60
        ? 'text-[#E8964F] font-medium'
        : 'text-gray-700';
  return (
    <span className={cls} title={`${days} day${days === 1 ? '' : 's'} since invoice sent`}>
      {display}
    </span>
  );
};

export default InvoiceSentDateCell;
